

















































































































import { Component, Vue } from "vue-property-decorator";
import { SurveyType, Attractor, SurveyStatusType } from "@/interfaces";

import { SurveyModule } from "@/store";
import { getMarkets, deleteMarket } from "@/services";
import { notifyError, notifySuccess } from "@/common/notify";

import { date } from "quasar";

@Component
export default class MarketsSurvey extends Vue {
  @SurveyModule.bindings.Mutation
  setSurveyType!: (type: SurveyType | null) => void;

  markets: Attractor[] = [];

  loading = false;

  filteredData: Attractor[] = [];

  searchText = "";

  async mounted() {
    try {
      this.markets = await getMarkets();
      this.setSurveyType(SurveyType.MARKET);
      this.filteredData = this.markets;
    } catch (error) {
      console.log(error);
    }
  }

  goToSurvey() {
    this.$router.push(`survey/${SurveyType.MARKET}`).catch(error => console.log(error));
  }

  dataSearchSubmit() {
    if (this.searchText.trim() !== "") {
      this.filteredData = this.markets.filter(market =>
        market.name.toLowerCase().includes(this.searchText.toLowerCase()),
      );
    } else {
      this.filteredData = this.markets;
    }
  }

  openShowMarket(market: Attractor) {
    this.$router.push(`survey/${SurveyType.MARKET}/${market.surveys[0].id}`).catch(error => console.log(error));
  }

  getMarketDate(market: Attractor) {
    return date.formatDate(market.surveys[0].updated_at, "DD/MM/YYYY HH:mm");
  }

  onDeleteMarket(market: Attractor) {
    this.$q
      .dialog({
        title: "Attenzione",
        message: `Sei sicuro di volere eliminare il mercato <strong>${market.name}</strong>`,
        html: true,
        cancel: true,
      })
      .onOk(() => {
        this.deleteMarketAction(market);
      });
  }

  async deleteMarketAction(market: Attractor) {
    try {
      await deleteMarket(market.surveys[0].id);
      this.markets = await getMarkets();
      this.filteredData = this.markets;
      this.searchText = "";
      notifySuccess("Mercato rimosso con successo!");
    } catch (error) {
      console.log(error);
      notifyError("Errore imprevisto, non è stato possibile eliminare il mercato!");
    }
  }

  get statusLabelClass() {
    return (status: SurveyStatusType) => {
      switch (status) {
        case SurveyStatusType.COMPLETED:
          return "text-positive";
        case SurveyStatusType.IN_PROGRESS:
          return "text-warning";
        default:
          return "";
      }
    };
  }

  get statusLabel() {
    return (status: SurveyStatusType) => {
      switch (status) {
        case SurveyStatusType.COMPLETED:
          return "Completato";
        case SurveyStatusType.IN_PROGRESS:
          return "Da Completare";
        default:
          return "Indefinito";
      }
    };
  }

  get columns() {
    return [
      {
        name: "name",
        label: "Nome",
        field: "name",
        align: "left",
        sortable: true,
      },
      {
        name: "status",
        label: "Stato",
        field: (row: Attractor) => (row.surveys.length > 0 ? this.statusLabel(row.surveys[0].status) : ""),
        align: "left",
        sortable: true,
      },
      {
        label: "Ultima modifica",
        name: "date",
        field: (row: Attractor) =>
          row.surveys.length > 0 ? date.formatDate(row.surveys[0].updated_at, "DD/MM/YYYY HH:mm") : "",
        align: "left",
        sortable: true,
      },
      { name: "edit", align: "center" },
      { name: "complete", align: "center" },
      { name: "delete", align: "center" },
    ];
  }
}
